import { Injectable } from '@angular/core';

import { RestService } from '../core/rest.service';

import { objectToQueryString } from '../../common/utils';

import { environment } from '../../../environments/environment';

@Injectable()
export class StaffCalendarService {
  constructor(private readonly rest: RestService) {}

  async getCalendar(date: string, view: string, params: any = {}): Promise<any> {
    const query = objectToQueryString({
      ...params,
      date,
      view,
    });

    return this.rest.get(`${environment.apiUrl}/api/staff/calendar${query}`);
  }
}
